import React from 'react';
import { siteConfig } from '../../config/siteConfig';

interface StoriesBarProps {
  storySelected: string;
  setStorySelected: (story: string) => void;
}

const StoriesBar: React.FC<StoriesBarProps> = ({ storySelected, setStorySelected }) => {
  const handleClick = (buttonName: string) => {
    console.log(`${buttonName} clicked`);
    setStorySelected(buttonName);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', background: '#EFEFEF', height: '35px', padding: '0 10px' }}>
      {siteConfig.storyTabs.map((tab, i) => (
        <div
          key={tab.key}
          style={{
            marginLeft: i === 0 ? 0 : '20px',
            cursor: 'pointer',
            backgroundColor: storySelected === tab.key ? 'black' : 'transparent',
            color: storySelected === tab.key ? 'white' : 'black',
            fontWeight: 'bold',
            padding: '5px 10px',
            textDecoration: storySelected === tab.key && tab.type === 'interactive' ? 'underline' : 'none',
          }}
          onClick={() => {
            if (tab.type === 'pdf' && tab.url) {
              window.open(tab.url, '_blank');
            } else {
              handleClick(tab.key);
            }
          }}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default StoriesBar;
